<template>
  <div class="flex items-center text-sm text-white max-lg:justify-end">
    <AuthUserNavItem />
    <ShopSharedWishlist />
    <ShopSharedCart />
    <HamburgerMenu class="pl-2 lg:ml-3 lg:px-1 xl:ml-4 xl:px-4" />
  </div>
</template>
